import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-shield-disabled-icon',
  templateUrl: './general-shield-disabled.component.html'
})
export class GeneralShieldDisabledComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
